module.exports = __webpack_public_path__ + "ic-purchase.svg?280b10bc7b8540fc3139b14e428158dc";